import "./i18n"
import "index.css"

import { Amplify } from "aws-amplify"
import React from "react"
import ReactDOM from "react-dom/client"
import { RouterProvider } from "react-router-dom"

import ThemeProvider from "@mui/material/styles/ThemeProvider"

import DefaulTheme from "./config/theme"
import { AmplifyConfig } from "./constants/amplify"
import routes from "./routes"
import { SnackbarProvider } from "notistack"

Amplify.configure(AmplifyConfig)

// tslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = ReactDOM.createRoot(document.querySelector("#root")!)
root.render(
  <React.StrictMode>
    <SnackbarProvider anchorOrigin={{ vertical: "top", horizontal: "center" }}>
      <ThemeProvider theme={DefaulTheme}>
        <RouterProvider router={routes} />
      </ThemeProvider>
    </SnackbarProvider>
  </React.StrictMode>,
)
